export const ICoreEventsRepositoryType = Symbol('ICoreEventsRepository');
